
import React from "react";
// react library for routing
import { Link } from "react-router-dom";
// reactstrap components
import { Button, Card, CardBody, Container, Row, Col } from "reactstrap";

class IndexHeader extends React.Component {
  render() {
    return (
      <>
        <div className="header bg-info pt-5 pb-7">
          <Container>
            <div className="header-body">
              <Row className="align-items-center">
                <Col lg="6">
                  <div className="pr-5">
                    <h1 className="display-2 text-indigo font-weight-bold mb-0">
                      CCL Magic
                    </h1>
                    <h2 className="display-4 text-blue font-weight-light">
                      GIÁ TRỊ HỌC VIÊN NHẬN ĐƯỢC.
                    </h2>
                    <p className="text-blue mt-4">
                      Để vượt qua bài thi CCL đầy thử thách, CCL MAGIC tin rằng chương trình luyện thi sát thực tế, tài liệu chất lượng, phong phú, Platform tiện lợi, cùng với sự hướng dẫn tận tuỵ của các giảng viên kinh nghiệm chính là chìa khoá giúp các bạn chinh phục kì thi trong thời gian ngắn nhất.
                    </p>
                    <div className="mt-5">
                      <Button
                        className="btn-neutral my-2"
                        color="default"
                        to="/user/home"
                        tag={Link}
                      >
                        Đăng ký tư vấn
                      </Button>
                      <Button
                        className="my-2"
                        color="default"
                        to="/user/home"
                        tag={Link}
                      >
                        Trải nghiệm miễn phí
                      </Button>
                    </div>
                  </div>
                </Col>
                <Col lg="6">
                  <Row className="pt-5">
                    <Col md="6">
                      <Card>
                        <CardBody>
                          <div className="mb-2">
                            <div className={`bg-icon-60 bg-topic-default bg-topic-trainer-60`}></div>
                          </div>
                          <h5 className="h3">TRAINER KINH NGHIỆM</h5>
                          <p>
                          Với nhiều năm kinh nghiệm dịch thuật và luyện thi Naati, CCL.
                          Vốn kiến thức sâu rộng, cùng sự tận tâm trong phương pháp giảng dạy, các Trainer hiểu rõ bạn cần gì và làm thế nào để vượt qua bài thi CCL.
                          </p>
                        </CardBody>
                      </Card>
                      <Card>
                        <CardBody>
                          <div className="mb-2">
                            <div className={`bg-icon-60 bg-topic-default bg-topic-target-60`}></div>
                          </div>
                          <h5 className="h3">KHOÁ HỌC CHUYÊN BIỆT CHO TỪNG TARGET</h5>
                          <p>
                            Magic hiểu rằng đối với mỗi background, mỗi cá nhân, phương pháp tiếp cận bài thi CCL sẽ khác nhau. Dựa trên điểm yếu, điểm mạnh và các giờ học 1:1, học viên sẽ được điều chỉnh, tối ưu phương pháp luyện tập thật hiệu quả. 
                          </p>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col className="pt-lg-5 pt-4" md="6">
                      <Card className="mb-4">
                        <CardBody>
                          <div className="mb-2">
                            <div className={`bg-icon-60 bg-topic-default bg-topic-document-60`}></div>
                          </div>
                          <h5 className="h3">TÀI LIỆU PHONG PHÚ ĐA DẠNG</h5>
                          <p>
                            Khó khăn thường gặp đối với luyện thi CCL đó là nguồn tài liệu hạn chế. Vì vậy đội ngũ trainer tại MAGIC đã biên soạn riêng Ngân hàng tài liệu bao gồm Mocktest, từ vựng bám sát các chủ đề, yêu cầu với bài thi thật. Tích hợp trên CCL Platform, giúp luyện tập trở nên thật đơn giản & hiệu quả.
                          </p>
                        </CardBody>
                      </Card>
                      <Card className="mb-4">
                        <CardBody>
                          <div className="mb-2">
                            <div className={`bg-icon-60 bg-topic-default bg-topic-money-60`}></div>
                          </div>
                          <h5 className="h3">TIẾT KIỆM CHI PHÍ</h5>
                          <p>
                            Tại MAGIC khoá học được tối ưu không chỉ mang đến chất lượng luyện thi ưu việt mà còn với một chi phí phù hợp với nhiều hình thức học và nhiều hỗ trợ đặc biệt cho các học viên. 
                          </p>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </Container>
          <div className="separator separator-bottom separator-skew zindex-100">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="fill-default"
                points="2560 0 2560 100 0 100"
              />
            </svg>
          </div>
        </div>
      </>
    );
  }
}

export default IndexHeader;
